// React imports
import React from 'react';
import * as PropTypes from 'prop-types';
// Material UI Imports
import {
  Grid, Button, Dialog, Fade, withStyles,
} from '@material-ui/core';
import ReactTippyWrapper from '../ReactTippyWrapper';
// Porject imports
import LikeIcon from '../LikeIcon';
import TimeAgo from '../TimeAgo';
import ShareTooltip from '../ShareTooltip';
import VCProfile from '../../containers/VCProfile';
// Assets Imports
import lightboxreply from '../../assets/images/lightboxreply.svg';
import next from '../../assets/images/next.svg';
import prev from '../../assets/images/prev.svg';
import closeModal from '../../assets/images/close-modal.svg';
import styles from './styles';
import './index.scss';

function Transition(props) {
  return <Fade {...props} />;
}

const VCLightbox = (props) => {
  const {
    isOpen, classes, onClose, onNext, onPrev, dataSet, currentIndex, onLikeActivity, openDrawingTool,
    disable, userLevel, vcId, authFollowAction,
  } = props;
  const currentData = dataSet[currentIndex];
  const shouldShowNext = currentIndex < dataSet.length - 1;
  const shouldShowPrev = currentIndex > 0;

  return (
    <div>
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={false}
        scroll="body"
        className="materialModalScrollFix"
        classes={{ paper: classes.dialogPaper, container: 'vhAlignCenter' }}
        BackdropProps={{
          classes: {
            root: classes.backdropTada,
          },
        }}
      >
        <img
          src={currentData.src}
          alt="VC Drawing"
        />
        {shouldShowNext
          && (
            <Button className="next navigationBtn" onClick={onNext}>
              <img alt=">" src={next} />
            </Button>
          )}
        {shouldShowPrev
          && (
            <Button className="prev navigationBtn" onClick={onPrev}>
              <img alt="<" src={prev} />
            </Button>
          )
        }
        <div className="lightboxCaption">
          <Grid container direction="row" justify="space-between" alignItems="center">
            <Grid item>
              <VCProfile id={currentData.ownerId} onAvatarClick={onClose} authFollowAction={authFollowAction} vcId={vcId} />
            </Grid>
            {(userLevel === 1 || !userLevel) ? null : (
              <Grid item className="replyBtn">
                <ReactTippyWrapper
                  title={!disable(currentData.user_can_reply, currentData.level) ? ' '
                    : 'All 4 replies have filled for this drawing'}
                  position="bottom"
                >
                  <Button
                    disabled={disable(currentData.user_can_reply, dataSet[0].level)}
                    className={classes.btnReply}
                    onClick={() => {
                      openDrawingTool(true, currentData.id, vcId, currentData.title);
                    }}
                  >
                    <img alt="" src={lightboxreply} />
                  </Button>
                </ReactTippyWrapper>
              </Grid>
            )}
            <Grid item>
              <Grid container direction="row" alignItems="center" justify="flex-end">
                <Grid item className="duration"><TimeAgo datetime={currentData.created_at} /></Grid>
                <Grid item>
                  <Button
                    onClick={() => onLikeActivity(currentData.id, currentData.likes_count, currentData.parentIdsTrail)}
                    className={`${classes.btnLikeShare} ${classes.rightSpace} likeButton`}
                  >
                    <LikeIcon liked={currentData.liked_by_user} />
                  </Button>
                </Grid>
                <Grid item>
                  <ShareTooltip buttonClassName={classes.btnLikeShare} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Button className="closeLightbox" onClick={onClose} />
        </div>
      </Dialog>
    </div>
  );
};

VCLightbox.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  vcId: PropTypes.number.isRequired,
  authFollowAction: PropTypes.string.isRequired,
};

export default withStyles(styles)(VCLightbox);



// WEBPACK FOOTER //
// ./src/components/VCLightbox/index.js